var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExternallink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36667 13.3334L2.66667 12.6334L10.9667 4.33337H6.06667V3.33337H12.6667V9.93337H11.6667V5.03337L3.36667 13.3334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExternallink);
export default __webpack_public_path__ + "static/media/icon_external link.3d780e0157b3a8a82a88df2b3a0f8cb1.svg";
export { ForwardRef as ReactComponent };